import React from 'react'
import classNames from 'classnames'
import { getControlParts } from './Control'
import { InputProps } from './Input'

export function TextArea(props: InputProps) {
	let inputClass = classNames('textarea', {'is-danger': props.errorMessage})

	const controlProps = getControlParts(props)

	const changeHandler: React.ChangeEventHandler<HTMLTextAreaElement> = (e) => props.onChange(e.target.value)

	const inputControl = (
		<div className='textarea-component field'>
			{controlProps.labelElement}
			<div className='control'>
				<textarea id={controlProps.inputId} className={inputClass} value={props.value} onChange={changeHandler} disabled={props.disabled} />
			</div>
			{controlProps.helpTextElement}
		</div>
	)

	return props.isInColumn ? <div className='column'>{inputControl}</div> : inputControl
}

export default TextArea
